var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "program_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#program_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.25c-.35 0-.646-.121-.888-.363A1.206 1.206 0 013.25 12c0-.35.12-.646.362-.887.242-.242.538-.363.888-.363s.646.121.888.363c.241.241.362.537.362.887s-.12.646-.362.887a1.208 1.208 0 01-.888.363zm0-6c-.35 0-.646-.121-.888-.363A1.206 1.206 0 013.25 6c0-.35.12-.646.362-.888A1.21 1.21 0 014.5 4.75c.35 0 .646.12.888.362.241.242.362.538.362.888s-.12.646-.362.887a1.208 1.208 0 01-.888.363zm0 12c-.35 0-.646-.121-.888-.363A1.206 1.206 0 013.25 18c0-.35.12-.646.362-.887.242-.242.538-.363.888-.363s.646.121.888.363c.241.241.362.537.362.887s-.12.646-.362.887a1.208 1.208 0 01-.888.363zm4.5-.5a.728.728 0 01-.75-.75.728.728 0 01.75-.75h11c.217 0 .396.07.538.212a.731.731 0 01.212.538c0 .217-.07.396-.212.538a.731.731 0 01-.538.212H9zm0-6a.726.726 0 01-.75-.75.728.728 0 01.75-.75h11c.217 0 .396.07.538.212a.731.731 0 01.212.538.728.728 0 01-.75.75H9zm0-6A.726.726 0 018.25 6 .726.726 0 019 5.25h11a.728.728 0 01.75.75.728.728 0 01-.75.75H9z",
    fill: "#12385C"
  }))));
}
export default SvgProgram;